/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";


//i18n
import { withNamespaces } from "react-i18next";
import { useSelector } from "react-redux";

// import Button from "../Button"

// icon
import { TASK_TYPE_GROUPS } from "../../constants/TASK";

// util
import { taskRequest } from "../../utils/task";
import { classnames } from "../../utils/text";
import setTrialType from "../../utils/trial";
import Icon from "../Icon";

const taskIssueList = TASK_TYPE_GROUPS



const TaskItem = ({ type, icon, label, hide, disabled, isTrial: _isTrial }) => {

  const { company } = useSelector((store) => store.Profile);
  const isTrial = useMemo(() => {
    return company && company.isTrial && !_isTrial
  }, [_isTrial, company])

  return <div className={classnames("issue-button-box", {
    hide: hide,
    disabled: disabled,
    isTrial: isTrial
  })}>
    <a
      className={classnames("issue-button")}
      onClick={() => isTrial ? setTrialType('task') : !disabled && taskRequest(type)}
    >
      <span className="icon">
        <Icon src={icon} />
      </span>
      {label}
    </a>
  </div>
}

const TaskIssueList = ({ activeType = "all" }) => (
  <>
    <div className="task-issue-list-wrap">
      {taskIssueList
        .filter(({ type }) => activeType === type || activeType === "all")
        .map(({ type, issues, label }, idx) => (
          <div className="task-issue-list-box" key={idx}>
            <h4 className="task-type-name">{label || type}</h4>
            <div className="task-issue-list">
              {issues.map((issue, index) => (
                <TaskItem {...issue} key={index} />
              ))}
            </div>
          </div>
        )
        )}
    </div>
  </>
);

export default withNamespaces()(TaskIssueList);
